var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "priting-template directions-template" },
    [
      _c("h2", { domProps: { innerHTML: _vm._s(_vm.contentTitle) } }),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          _vm._s(_vm.humanizedSummary(_vm.activeRoute.summary).distance) + " "
        )
      ]),
      _vm._v(" & "),
      _c("b", [
        _vm._v(
          _vm._s(_vm.humanizedSummary(_vm.activeRoute.summary).duration) + " "
        )
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("img", {
        attrs: { width: "auto", height: "400", src: _vm.mapViewImage }
      }),
      _vm._v(" "),
      _vm._l(_vm.activeRoute.properties.segments, function(
        segment,
        segmentIndex
      ) {
        return [
          _c("h3", { key: segmentIndex + "header" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("print.segment")) +
                " " +
                _vm._s(Number(segmentIndex) + 1) +
                " "
            )
          ]),
          _vm._v(" "),
          _vm.activeRoute.properties.segments.length > 1
            ? _c("div", { key: segmentIndex }, [
                _c("b", [
                  _vm._v(_vm._s(_vm.humanizedSummary(segment).distance) + " ")
                ]),
                _vm._v(" &\n        "),
                _c("b", [
                  _vm._v(_vm._s(_vm.humanizedSummary(segment).duration) + " ")
                ]),
                _vm._v(" "),
                _c("br"),
                _c("br")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(segment.steps, function(step, stepIndex) {
            return [
              _c("div", { key: segmentIndex + "_" + stepIndex }, [
                step.distance && step.duration
                  ? _c("div", [
                      _vm._v(
                        "\n          (" +
                          _vm._s(
                            _vm.getGlobalStepCounter(segmentIndex, stepIndex)
                          ) +
                          ")\n          "
                      ),
                      _c("span", {
                        staticStyle: { "font-size": "24px" },
                        domProps: { innerHTML: _vm._s(_vm.getStepSymbol(step)) }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(step.instruction) }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("  ⊶\n          "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.humanizedSummary(step).distance) + " "
                        )
                      ]),
                      _vm._v(" &\n          "),
                      _c("b", [
                        _vm._v(
                          _vm._s(_vm.humanizedSummary(step).duration) + " "
                        )
                      ]),
                      _vm._v(" "),
                      _c("br")
                    ])
                  : _c("div", [
                      _c("span", { staticStyle: { "font-size": "24px" } }, [
                        _vm._v("⊙")
                      ]),
                      _vm._v(" "),
                      _c("b", {
                        domProps: { innerHTML: _vm._s(step.instruction) }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _c("br")
                    ])
              ])
            ]
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7cd132", { render: render, staticRenderFns: staticRenderFns })
  }
}